var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComprehensive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_517)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_60_517)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_60_517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.8926 0H30.0176C30.0176 1.74048 29.3262 3.40968 28.0955 4.64039C26.8648 5.8711 25.1956 6.5625 23.4551 6.5625V8.4375C25.1956 8.4375 26.8648 9.1289 28.0955 10.3596C29.3262 11.5903 30.0176 13.2595 30.0176 15H31.8926C31.8926 13.2595 32.584 11.5903 33.8147 10.3596C35.0454 9.1289 36.7146 8.4375 38.4551 8.4375V6.5625C36.7146 6.5625 35.0454 5.8711 33.8147 4.64039C32.584 3.40968 31.8926 1.74048 31.8926 0ZM0.955078 18.75C6.51008 18.75 9.70508 21.875 9.70508 27.5H12.2051C12.2051 21.875 15.3301 18.75 20.9551 18.75V16.25C15.3301 16.25 12.2051 13.125 12.2051 7.5H9.70508C9.70508 13.125 6.58008 16.25 0.955078 16.25V18.75ZM26.8926 40C26.8926 38.2595 27.584 36.5903 28.8147 35.3596C30.0454 34.1289 31.7146 33.4375 33.4551 33.4375V31.5625C31.7146 31.5625 30.0454 30.8711 28.8147 29.6404C27.584 28.4097 26.8926 26.7405 26.8926 25H25.0176C25.0176 26.7405 24.3262 28.4097 23.0955 29.6404C21.8648 30.8711 20.1956 31.5625 18.4551 31.5625V33.4375C20.1956 33.4375 21.8648 34.1289 23.0955 35.3596C24.3262 36.5903 25.0176 38.2595 25.0176 40H26.8926Z",
    fill: "url(#paint0_linear_60_517)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_60_517",
    x1: 5.68131,
    y1: -24.6545,
    x2: 49.2482,
    y2: -16.3028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0395,
    stopColor: "#240B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3D1E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671382,
    stopColor: "#8319B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9428,
    stopColor: "#BC14FE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.955078)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_60_517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.955078)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_60_517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.955078)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComprehensive);
export default __webpack_public_path__ + "static/media/comprehensive.c568b01cc8fd9d54b7530ccbee6e9f83.svg";
export { ForwardRef as ReactComponent };